import { useApi } from "./useApi.ts";
import { ProductItem } from "../pages/product_manager/types.ts";
import { saveAs } from "file-saver";

const API_BASE = process.env.REACT_APP_API_BASE as string;   // Vite 예시

export const useProductItemApi = () => {
    const { apiFetch } = useApi()

    const insertProductItem = async (form: ProductItem) => {
        const res = await apiFetch(`${API_BASE}/product/item/insert`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("server " + res.status);
        return res.blob();
      };

    const updateProductItem = async (form: ProductItem) => {
        const res = await apiFetch(`${API_BASE}/product/item/${form.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("server " + res.status);
        return res.blob();
      }

    const deleteProductItem = async (id: String) => {
        const res = await apiFetch(`${API_BASE}/product/item/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
        });

        if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "삭제 실패");
        }

        const data = await res.json();
        console.log("삭제 결과:", data);
        return data
    }

    // 데이터 로딩
    const getAllProductItem = async () => {
        const res = await apiFetch(`${API_BASE}/product/item/get`);
        const json = await res.json();
        return json
    };

    return {
        insertProductItem,
        updateProductItem,
        deleteProductItem,
        getAllProductItem
    }
}
